import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";

export default function Referral() {
    const {referral} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.setItem('referral', String(referral));
        navigate('/login?tab=1');
    }, [referral]);

    return (
        <>Redirecting to the registration page...</>
    );
}